module.exports = "<p>\r\n  investmentcontract works!\r\n</p>\r\n"